import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react'

function DeleteDialog({handleDelete, open, handleCloseDialog, message}) {

  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      dir='rtl'
    >
      <DialogTitle id="alert-dialog-title">{"تأكيد الحذف"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog} autoFocus color={"error"}>
          إغلاق
        </Button>
        <Button
          onClick={handleDelete}
          variant="contained"
          color={"error"}
          sx={{marginRight: "8px"}}
        >
          حذف
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteDialog